import React, { forwardRef } from 'react';
import MUICard, { CardProps as MUICardProps } from '@material-ui/core/Card';

export interface CardProps extends MUICardProps {}

const Card = forwardRef<HTMLAreaElement, CardProps>((props, ref) => {
  return <MUICard {...props} ref={ref} />;
});

Card.displayName = 'Card';

export default Card;
